import { render, staticRenderFns } from "./DashboardItemWrapper.vue?vue&type=template&id=80b5ac5e&"
import script from "./DashboardItemWrapper.vue?vue&type=script&lang=js&"
export * from "./DashboardItemWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports